/* eslint-disable react/prefer-es6-class, arrow-body-style, react/sort-comp, react/jsx-no-bind */
import classnames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Keys, { KeyHelpers } from 'es6/core/keys';
import DropZone from 'es6/components/apps/sentence-builder/drop-zone';
import WordPiece from 'es6/components/apps/sentence-builder/word-piece';

export default React.createClass({
  displayName: 'WordChoices',

  propTypes: {
    data: React.PropTypes.array.isRequired,
    enableKeyEvents: React.PropTypes.bool,
    onDrop: React.PropTypes.func.isRequired,
    onClick: React.PropTypes.func.isRequired,
  },

  getDefaultProps() {
    return {
      enableKeyEvents: true,
    };
  },

  getInitialState() {
    return {
      keyPositionIndex: 0,
    };
  },

  componentDidMount() {
    document.addEventListener('keydown', this._handleKeyDown);
  },

  componentWillUnmount() {
    document.removeEventListener('keydown', this._handleKeyDown);
  },

  _handleKeyDown(e) {
    if (!this.props.enableKeyEvents) {
      return;
    }

    e.preventDefault();

    const onEnter = () => {
      const wordChoice = this.props.data[this.state.keyPositionIndex];
      this.props.onClick.call(null, wordChoice);
    };

    if (KeyHelpers.isDirectional(e.keyCode)) {
      this._setKeyboardSelection(e.keyCode);
    } else if (e.keyCode === Keys.ENTER) {
      onEnter();
    }
  },

  /**
   * Targets and highlights for the currently selected word piece.
   *
   * @param {Number} keyCode
   * @returns {Number}
   */
  _setKeyboardSelection(keyCode) {
    let keyPositionIndex = this.state.keyPositionIndex;
    const wordChoicesLength = this.props.data.length;

    // Executed if the case is UP or DOWN.
    const onVerticalMove = () => {
      const wordChoiceNode = ReactDOM.findDOMNode(this.refs.wordChoices);
      const wordPieceNodes = [...wordChoiceNode.querySelectorAll('.word-piece')];
      const referenceNode = wordPieceNodes[keyPositionIndex];

      // Create an array of candidate nodes to check based on whether they are above
      // or below the selected node.
      const candidateNodes = wordPieceNodes.filter(node => {
        return KeyHelpers.isUp(keyCode) ?
          referenceNode.offsetTop > node.offsetTop :
          referenceNode.offsetTop < node.offsetTop;
      });

      // If there any candidates, simply grab the one with the
      // closest left offset and then set the key position to be
      // the index of it.
      if (candidateNodes.length > 0) {
        const closestNode = candidateNodes.reduce((prev, next) => {
          const prevOffset = Math.abs(prev.offsetLeft - referenceNode.offsetLeft);
          const nextOffset = Math.abs(next.offsetLeft - referenceNode.offsetLeft);

          return prevOffset > nextOffset ? next : prev;
        });

        keyPositionIndex = wordPieceNodes.indexOf(closestNode);
      }
    };

    if (KeyHelpers.isRight(keyCode)) {
      // User intends to move forward or wrap around to beginning.
      keyPositionIndex = (keyPositionIndex + 1) % wordChoicesLength;
    } else if (KeyHelpers.isLeft(keyCode)) {
      // User intends to move backward or wrap around to ending.
      keyPositionIndex = (((keyPositionIndex - 1 % wordChoicesLength) + wordChoicesLength) % wordChoicesLength);
    } else if (KeyHelpers.isDown(keyCode) || KeyHelpers.isUp(keyCode)) {
      onVerticalMove();
    }

    this.setState({ keyPositionIndex });
  },

  render() {
    return (
      <section className="word-choices" ref="wordChoices">
        <DropZone onDrop={this.props.onDrop.bind(null, null)}>
          {this.props.data.map((word, i) => this._renderWordPiece(word, i))}
        </DropZone>
      </section>
    );
  },

  /**
   * Renders a word piece.
   *
   * @param {WordChoice} wordChoice
   * @param {Number} index
   * @returns {ReactElement}
   */
  _renderWordPiece(wordChoice, index) {
    const props = {
      className: classnames({
        highlighted: this.props.enableKeyEvents && this.state.keyPositionIndex === index,
        freed: !wordChoice.used,
        used: wordChoice.used,
      }),
      key: index,
      enableDragEvents: !wordChoice.used,
      onClick: this.props.onClick,
      wordChoice,
    };

    return (<WordPiece {...props}>{wordChoice.value}</WordPiece>);
  },
});
